<template>
  <LayoutColumns>
    <template #leftSidebar>
      <SidebarMenu :top-list="menu" />
    </template>
    <LayoutWithRightSidebar breakpoint="xl">
      <template #rightSidebar>
        <NewsRightSidebar />
      </template>
      <div class="flex flex-col gap-4">
        <div
          class="flex gap-2 px-2 sm:px-0 lg:hidden overflow-x-scroll max-w-full py-1"
        >
          <SidebarMenuItem
            v-for="section in menu"
            :key="section.id"
            :item="section"
            theme="white"
          />
        </div>

        <ShowcasesForm v-if="authStore.profile" />
        <BaseCard v-else>
          <div
            class="py-8 flex flex-col space-y-4 justify-center items-center text-center"
          >
            <div class="sm:whitespace-pre-line">
              {{ $t('showcases.login_to_see_showcase_form') }}
            </div>
            <BaseButton
              theme="primary"
              look="border"
              @click="authStore.openLoginModal"
            >
              {{ $t('header.login') }}
            </BaseButton>
          </div>
        </BaseCard>
      </div>
    </LayoutWithRightSidebar>
  </LayoutColumns>
</template>

<script setup lang="ts">
import { useAuth } from '~/stores/auth'
import { useEvents } from '~/stores/events'

const eventsStore = useEvents()
const authStore = useAuth()

const menu = eventsStore.getSectionList()
</script>
